// import React, { useState, useEffect } from "react";
// import {
//   TextField,
//   MenuItem,
//   Button,
//   Grid,
//   IconButton,
//   Container,
//   TableContainer,
//   Table,
//   Box,
//   TableCell,
//   Autocomplete,
//   TableHead,
//   TableRow,
//   TableBody,
//   Card,
//   CardContent,
//   Typography,
//   useMediaQuery,
//   useTheme,
//   Divider,
//   alpha,
// } from "@mui/material";
// import { Visibility } from "@mui/icons-material";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import {
//   ApproveTransporterList,
//   CreatePurchaseVoucher,
//   fetchpos,
//   UpdatePurchaseVoucher,
//   GetNextPvNo,
//   GetPurchaseVoucherById,
// } from "../../../Services/Services";
// import { toast, ToastContainer } from "react-toastify";
// import { useLocation, useNavigate } from "react-router-dom";
// import { CircularProgress } from "@mui/material";

// const GoodReceivedForm = () => {
//   const theme = useTheme();
//   const isDark = theme.palette.mode === "dark";
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const getSelectedDivision = () => {
//     try {
//       const stored = localStorage.getItem("selectedDivision");
//       return stored ? JSON.parse(stored) : null;
//     } catch (e) {
//       console.error("Failed to parse selectedDivision:", e);
//       return null;
//     }
//   };

//   const storedDivision = getSelectedDivision();

//   const [formData, setFormData] = useState({
//     purchase_voucher_no: "",
//     purchase_number: "",
//     project: "",
//     indent: "",
//     purchase: "",
//     division: storedDivision?.division_id || "",
//     division_name: storedDivision?.division || "",
//     transporter_name: "",
//     invoice_number: "",
//     lr_no: "",
//     vehicle_no: "",
//     amount: "",
//     attachment: "",
//     payment_status: "",
//     supplier: "",
//     invoice_date: "",
//     narration: "",
//     gst_amount: "0.00",
//     gst_percentage: "",
//     total_amount: "0.00",
//     other_expense: 0,
//     final_amount: "0.00",
//     grn_no: "",
//     items: [
//       {
//         category: "",
//         sub_category: "",
//         item: "",
//         description: "",
//         quantity: "",
//         received_qty: "",
//         unit: "",
//         rate: "",
//         amount: "0.00",
//         size: "",
//         size_name: "",
//         gst_percentage: "",
//         gst_amount: "0.00",
//         item_total: "0.00",
//         category_name: "",
//         sub_category_name: "",
//         item_name: "",
//         unit_name: "",
//       },
//     ],
//     created_by: localStorage.getItem("user_id"),
//   });

//   const navigate = useNavigate();
//   const [purchases, setPurchases] = useState([]);
//   const [selectedPO, setSelectedPO] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [formErrors, setFormErrors] = useState({});
//   const [rowErrors, setRowErrors] = useState([]);
//   const [transporterLists, setTransporterLists] = useState([]);
//   const location = useLocation();
//   const editIssue = location.state?.issue || null;
//   const [existingFileName, setExistingFileName] = useState("");

//   // ── Calculate helpers ──
//   const calculateItemAmount = (qty, rate) =>
//     ((parseFloat(qty) || 0) * (parseFloat(rate) || 0)).toFixed(2);

//   const calculateItemGST = (amount, gstPercent) =>
//     (
//       ((parseFloat(amount) || 0) * (parseFloat(gstPercent) || 0)) /
//       100
//     ).toFixed(2);

//   const calculateItemTotal = (amount, gstAmount) =>
//     ((parseFloat(amount) || 0) + (parseFloat(gstAmount) || 0)).toFixed(2);

//   const calculateTotalAmount = (items) =>
//     items
//       .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)
//       .toFixed(2);

//   const calculateTotalGST = (items) =>
//     items
//       .reduce((sum, item) => sum + (parseFloat(item.gst_amount) || 0), 0)
//       .toFixed(2);

//   const calculateFinalAmount = (items, otherExpense) =>
//     (
//       items.reduce(
//         (sum, item) => sum + (parseFloat(item.item_total) || 0),
//         0
//       ) + (parseFloat(otherExpense) || 0)
//     ).toFixed(2);

//   const handleItemChange = (index, field, value) => {
//     const updatedItems = [...formData.items];
//     updatedItems[index][field] = value;
//     const row = updatedItems[index];

//     if (field === "received_qty" || field === "rate") {
//       row.amount = calculateItemAmount(row.received_qty, row.rate);
//       row.gst_amount = calculateItemGST(row.amount, row.gst_percentage);
//       row.item_total = calculateItemTotal(row.amount, row.gst_amount);
//     }

//     if (field === "gst_percentage") {
//       row.gst_amount = calculateItemGST(row.amount, row.gst_percentage);
//       row.item_total = calculateItemTotal(row.amount, row.gst_amount);
//     }

//     const totalAmount = calculateTotalAmount(updatedItems);
//     const totalGST = calculateTotalGST(updatedItems);
//     const finalAmount = calculateFinalAmount(
//       updatedItems,
//       formData.other_expense
//     );

//     setFormData((prev) => ({
//       ...prev,
//       items: updatedItems,
//       total_amount: totalAmount,
//       gst_amount: totalGST,
//       final_amount: finalAmount,
//     }));

//     const newRowErrors = [...rowErrors];
//     if (newRowErrors[index]) delete newRowErrors[index][field];
//     setRowErrors(newRowErrors);
//   };

//   const handleOtherExpenseChange = (value) => {
//     const otherExpense = value || "0.00";
//     const finalAmount = calculateFinalAmount(formData.items, otherExpense);
//     setFormData((prev) => ({
//       ...prev,
//       other_expense: otherExpense,
//       final_amount: finalAmount,
//     }));
//   };

//   const addItem = () => {
//     setFormData((prev) => ({
//       ...prev,
//       items: [
//         ...prev.items,
//         {
//           category: "",
//           sub_category: "",
//           item: "",
//           description: "",
//           quantity: "",
//           received_qty: "",
//           unit: "",
//           rate: "",
//           amount: "0.00",
//           size: "",
//           size_name: "",
//           gst_percentage: "",
//           gst_amount: "0.00",
//           item_total: "0.00",
//           category_name: "",
//           sub_category_name: "",
//           item_name: "",
//           unit_name: "",
//         },
//       ],
//     }));
//   };

//   const removeItem = (index) => {
//     if (formData.items.length === 1) {
//       toast.warning("At least one item is required");
//       return;
//     }
//     const items = formData.items.filter((_, i) => i !== index);
//     const totalAmount = calculateTotalAmount(items);
//     const totalGST = calculateTotalGST(items);
//     const finalAmount = calculateFinalAmount(items, formData.other_expense);

//     setFormData((prev) => ({
//       ...prev,
//       items,
//       total_amount: totalAmount,
//       gst_amount: totalGST,
//       final_amount: finalAmount,
//     }));
//     const newRowErrors = rowErrors.filter((_, i) => i !== index);
//     setRowErrors(newRowErrors);
//   };

//   const handlePOChange = (event, newValue) => {
//     setSelectedPO(newValue);
//     const divisionData = getSelectedDivision();

//     if (newValue) {
//       const mappedItems = (newValue.items || []).map((item) => ({
//         category: item.category?.id || item.category,
//         category_name: item.category?.name || item.category_name || "",
//         sub_category:
//           item.sub_category?.subcat_id ||
//           item.sub_category?.id ||
//           item.sub_category,
//         sub_category_name:
//           item.sub_category?.name || item.sub_category_name || "",
//         item: item.item?.id || item.item,
//         item_name: item.item?.name || item.item_name || "",
//         unit: item.unit?.id || item.unit,
//         unit_name: item.unit?.name || item.unit_name || "",
//         description: item.description || "",
//         quantity: item.quantity || "",
//         received_qty: "",
//         rate: item.rate || "",
//         amount: "0.00",
//         size: item.size || "",
//         size_name: item.size_name || "",
//         gst_percentage: item.gst_percentage || "",
//         gst_amount: "0.00",
//         item_total: "0.00",
//       }));

//       setFormData((prev) => ({
//         ...prev,
//         purchase: newValue.po_id || newValue.id,
//         project: newValue.project || "",
//         division: divisionData?.division_id || "",
//         division_name: divisionData?.division || "",
//         supplier: newValue.supplier || "",
//         indent: newValue.indent || "",
//         project_name: newValue.project_name || "",
//         supplier_name: newValue.supplier_name || "",
//         indent_no: newValue.indent_no || "",
//         items: mappedItems,
//         total_amount: "0.00",
//         gst_amount: "0.00",
//         final_amount: "0.00",
//       }));
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         purchase: "",
//         project: "",
//         division: divisionData?.division_id || "",
//         division_name: divisionData?.division || "",
//         supplier: "",
//         indent: "",
//         project_name: "",
//         supplier_name: "",
//         indent_no: "",
//         items: [
//           {
//             category: "",
//             sub_category: "",
//             item: "",
//             description: "",
//             quantity: "",
//             received_qty: "",
//             unit: "",
//             rate: "",
//             amount: "0.00",
//             size: "",
//             size_name: "",
//             gst_percentage: "",
//             gst_amount: "0.00",
//             item_total: "0.00",
//             category_name: "",
//             sub_category_name: "",
//             item_name: "",
//             unit_name: "",
//           },
//         ],
//         total_amount: "0.00",
//         gst_amount: "0.00",
//         final_amount: "0.00",
//       }));
//     }
//   };

//   const handleFieldChange = (field, value) => {
//     setFormData((prev) => ({ ...prev, [field]: value }));
//   };

//   useEffect(() => {
//     const initializeData = async () => {
//       await Promise.all([fetchNextPvNo(), fetchPOs(), fetchTransporterLists()]);
//     };
//     initializeData();
//   }, []);

//   const fetchNextPvNo = async () => {
//     try {
//       const data = await GetNextPvNo();
//       if (data && data.purchase_voucher_no) {
//         setFormData((prev) => ({
//           ...prev,
//           purchase_number: data.purchase_voucher_no,
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching next PV number:", error);
//     }
//   };

//   const fetchPOs = async () => {
//     try {
//       const divisionData = getSelectedDivision();
//       const filters = {
//         approval_status: "Approved",
//         ...(divisionData?.division_id && {
//           division: divisionData.division_id,
//         }),
//       };
//       const data = await fetchpos(filters);
//       if (Array.isArray(data.results)) {
//         setPurchases(data.results);
//       }
//     } catch (error) {
//       console.error("Error fetching POs:", error);
//     }
//   };

//   const fetchTransporterLists = async () => {
//     try {
//       const data = await ApproveTransporterList();
//       setTransporterLists(Array.isArray(data) ? data : data?.results || []);
//     } catch (error) {
//       console.error("Error fetching transporters:", error);
//     }
//   };

//   useEffect(() => {
//     const loadEditData = async () => {
//       if (editIssue && editIssue.purchase_voucher_no) {
//         try {
//           const fullData = await GetPurchaseVoucherById(
//             editIssue.purchase_voucher_no
//           );
//           const divisionData = getSelectedDivision();
//           if (fullData) {
//             if (fullData.attachment) {
//               const fullPath = fullData.attachment.split("/").pop();
//               const fileName = fullPath.split("?")[0];
//               setExistingFileName(fileName);
//             }
//             const po = purchases.find(
//               (p) => String(p.po_id) === String(fullData.purchase)
//             );
//             setSelectedPO(po || null);
//             setFormData({
//               purchase_voucher_no: fullData.purchase_voucher_no || "",
//               purchase_number: fullData.purchase_number || "",
//               division: divisionData?.division_id || fullData.division || "",
//               division_name:
//                 divisionData?.division || fullData.division_name || "",
//               project: fullData.project || "",
//               purchase: fullData.purchase || "",
//               supplier: fullData.supplier || "",
//               indent: fullData.indent || "",
//               project_name: fullData.project_name || "",
//               indent_no: fullData.indent_no || "",
//               supplier_name: fullData.supplier_name || "",
//               invoice_number: fullData.invoice_number || "",
//               invoice_date: fullData.invoice_date || "",
//               transporter_name: fullData.transporter_name || "",
//               lr_no: fullData.lr_no || "",
//               vehicle_no: fullData.vehicle_no || "",
//               payment_status: fullData.payment_status || "",
//               narration: fullData.narration || "",
//               total_amount: fullData.total_amount || "0.00",
//               gst_amount: fullData.gst_amount?.toString() || "0.00",
//               other_expense: fullData.other_expense || "0.00",
//               final_amount: fullData.final_amount || "0.00",
//               grn_no: fullData.grn_no || "",
//               gst_percentage: fullData.gst_percentage?.toString() || "",
//               attachment: fullData.attachment || "",
//               created_by: localStorage.getItem("user_id"),
//               items: (fullData.good_items || fullData.items || []).map(
//                 (item) => ({
//                   category: item.category || "",
//                   category_name: item.category_name || "",
//                   sub_category: item.sub_category || "",
//                   sub_category_name: item.sub_category_name || "",
//                   item: item.item || "",
//                   item_name: item.item_name || "",
//                   description: item.description || "",
//                   received_qty: item.received_qty || "",
//                   quantity: item.quantity || "",
//                   unit: item.unit || "",
//                   unit_name: item.unit_name || "",
//                   rate: item.rate || "",
//                   amount: item.amount || "0.00",
//                   size: item.size || "",
//                   size_name: item.size_name || "",
//                   gst_percentage: item.gst_percentage?.toString() || "",
//                   gst_amount: item.gst_amount?.toString() || "0.00",
//                   item_total: item.item_total?.toString() || "0.00",
//                 })
//               ),
//             });
//           }
//         } catch (error) {
//           toast.error("Failed to load voucher data");
//         }
//       }
//     };
//     if (editIssue && purchases.length > 0) {
//       loadEditData();
//     }
//   }, [editIssue, purchases]);

//   const validateForm = () => {
//     const errors = {};
//     const rowErrs = [];

//     if (!formData.purchase) errors.purchase = "Purchase Order is required";

//     formData.items.forEach((row, i) => {
//       const err = {};
//       if (!row.received_qty || row.received_qty === "")
//         err.received_qty = "Received Qty is required";
//       if (!row.rate || row.rate === "") err.rate = "Rate is required";
//       if (Object.keys(err).length) rowErrs[i] = err;
//     });

//     setFormErrors(errors);
//     setRowErrors(rowErrs);
//     return Object.keys(errors).length === 0 && rowErrs.every((e) => !e);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     if (!validateForm()) {
//       toast.error("Please fill all required fields (PO, Received Qty, Rate).");
//       setLoading(false);
//       return;
//     }

//     try {
//       const fd = new FormData();
//       fd.append("purchase_number", formData.purchase_number || "");
//       fd.append("purchase_voucher_no", formData.purchase_voucher_no || "");
//       fd.append("project", formData.project || "");
//       fd.append("purchase", formData.purchase || "");
//       fd.append("supplier", formData.supplier || "");
//       fd.append("indent", formData.indent || "");
//       fd.append("invoice_number", formData.invoice_number || "");
//       fd.append("invoice_date", formData.invoice_date || "");
//       fd.append("transporter_name", formData.transporter_name || "");
//       fd.append("lr_no", formData.lr_no || "");
//       fd.append("vehicle_no", formData.vehicle_no || "");
//       fd.append("payment_status", formData.payment_status || "");
//       fd.append("narration", formData.narration || "");
//       fd.append("total_amount", formData.total_amount || "0.00");
//       fd.append("gst_amount", formData.gst_amount || "0.00");
//       fd.append("other_expense", formData.other_expense || "0.00");
//       fd.append("final_amount", formData.final_amount || "0.00");
//       fd.append("grn_no", formData.grn_no || "");

//       if (formData.attachment instanceof File) {
//         fd.append("attachment", formData.attachment);
//       }

//       const cleanedItems = formData.items.map((row) => ({
//         category: row.category || null,
//         sub_category: row.sub_category || null,
//         item: row.item || null,
//         unit: row.unit || null,
//         description: row.description || "",
//         quantity: Number(row.quantity) || 0,
//         received_qty: Number(row.received_qty) || 0,
//         rate: Number(row.rate) || 0,
//         amount: Number(row.amount) || 0,
//         size: row.size || "",
//         gst_percentage: Number(row.gst_percentage) || 0,
//         gst_amount: Number(row.gst_amount) || 0,
//         item_total: Number(row.item_total) || 0,
//       }));

//       fd.append("good_items", JSON.stringify(cleanedItems));

//       let response;
//       if (editIssue && editIssue.purchase_voucher_no) {
//         response = await UpdatePurchaseVoucher(
//           editIssue.purchase_voucher_no,
//           fd
//         );
//         if (response) {
//           toast.success("Purchase Entry Updated Successfully!");
//           setTimeout(() => navigate("/dashboard/purchase-list"), 1500);
//         }
//       } else {
//         fd.append("created_by", localStorage.getItem("user_id"));
//         response = await CreatePurchaseVoucher(fd);
//         if (response) {
//           toast.success("Purchase Entry Created Successfully!");
//           setTimeout(() => navigate("/dashboard/purchase-list"), 1500);
//         }
//       }
//     } catch (err) {
//       console.error("Submit error:", err);
//       toast.error(
//         err.response?.data?.message || "Operation failed! Check console."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Shared disabled field bg ──
//   const disabledBg = isDark
//     ? alpha(theme.palette.common.white, 0.06)
//     : "#f5f5f5";

//   // ── Mobile Item Card ──
//   const MobileItemCard = ({ row, index }) => (
//     <Card
//       elevation={0}
//       sx={{
//         mb: 1.5,
//         border: "1px solid",
//         borderColor: "divider",
//         borderRadius: 1,
//         bgcolor: "background.paper",
//         backgroundImage: "none",
//         boxShadow: isDark ? "0 2px 10px rgba(0,0,0,0.35)" : "none",
//       }}
//     >
//       <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
//         <Box
//           display="flex"
//           justifyContent="space-between"
//           alignItems="center"
//           mb={1}
//         >
//           <Typography
//             variant="subtitle2"
//             sx={{
//               fontSize: "0.8rem",
//               fontWeight: 700,
//               color: "primary.main",
//             }}
//           >
//             Item #{index + 1}
//           </Typography>
//           <IconButton
//             color="error"
//             size="small"
//             onClick={() => removeItem(index)}
//             disabled={formData.items.length === 1}
//             sx={{
//               "&:hover": {
//                 bgcolor: (t) =>
//                   t.palette.mode === "dark"
//                     ? alpha(t.palette.error.main, 0.15)
//                     : "#ffebee",
//               },
//             }}
//           >
//             <DeleteOutlineIcon fontSize="small" />
//           </IconButton>
//         </Box>

//         <Divider sx={{ mb: 2, borderColor: "divider" }} />

//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Category"
//               value={row.category_name || ""}
//               size="small"
//               disabled
//               sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Item"
//               value={row.item_name || ""}
//               size="small"
//               disabled
//               sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Size"
//               value={row.size_name || ""}
//               size="small"
//               disabled
//               sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="UOM"
//               value={row.unit_name || ""}
//               size="small"
//               disabled
//               sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="PO Qty"
//               type="number"
//               value={row.quantity || 0}
//               size="small"
//               disabled
//               sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Received Qty"
//               type="number"
//               value={row.received_qty || ""}
//               onChange={(e) =>
//                 handleItemChange(index, "received_qty", e.target.value)
//               }
//               size="small"
//               error={!!rowErrors[index]?.received_qty}
//               helperText={rowErrors[index]?.received_qty}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Rate"
//               type="number"
//               value={row.rate || ""}
//               onChange={(e) =>
//                 handleItemChange(index, "rate", e.target.value)
//               }
//               size="small"
//               error={!!rowErrors[index]?.rate}
//               helperText={rowErrors[index]?.rate}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="GST %"
//               type="number"
//               value={row.gst_percentage || ""}
//               onChange={(e) =>
//                 handleItemChange(index, "gst_percentage", e.target.value)
//               }
//               size="small"
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Amount"
//               value={row.amount}
//               size="small"
//               disabled
//               sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="GST Amt"
//               value={row.gst_amount}
//               size="small"
//               disabled
//               sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Item Total"
//               value={row.item_total}
//               size="small"
//               disabled
//               sx={{
//                 "& .MuiInputBase-root": {
//                   bgcolor: disabledBg,
//                   fontWeight: "bold",
//                 },
//               }}
//             />
//           </Grid>
//         </Grid>
//       </CardContent>
//     </Card>
//   );

//   return (
//     <Box
//       sx={{
//         px: { xs: 1, sm: 0 },
//         mt: { xs: 4, md: 0 },
//         bgcolor: "background.default",
//         minHeight: "100%",
//       }}
//     >
//       {/* ── Top Action Bar ── */}
//       <Grid
//         container
//         spacing={1}
//         alignItems="center"
//         sx={{
//           mb: 1,
//           mt: { xs: 3, md: 0 },
//           position: "sticky",
//           top: 0,
//           zIndex: 1100,
//           pt: 1,
//           pb: 1,
//           borderBottom: "1px solid",
//           borderColor: "divider",
//           bgcolor: (t) => alpha(t.palette.background.paper, 0.95),
//           backdropFilter: "blur(8px)",
//           boxShadow: isDark
//             ? "0 2px 10px rgba(0,0,0,0.45)"
//             : "0 1px 4px rgba(0,0,0,0.07)",
//         }}
//       >
//         {/* Spacer — desktop only */}
//         <Grid
//           item
//           sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
//         />

//         {/* Back */}
//         <Grid item xs={6} sm="auto">
//           <Button
//             fullWidth
//             variant="outlined"
//             onClick={() => navigate(-1)}
//             sx={{
//               height: 32,
//               fontSize: { xs: "0.65rem", sm: "0.7rem" },
//               borderRadius: 0,
//               px: { xs: 1, sm: 2 },
//               minWidth: { sm: 100 },
//               whiteSpace: "nowrap",
//             }}
//           >
//             ← Back
//           </Button>
//         </Grid>

//         {/* Submit */}
//         <Grid item xs={6} sm="auto">
//           <Button
//             fullWidth
//             variant="contained"
//             onClick={handleSubmit}
//             disabled={loading}
//             sx={{
//               height: 32,
//               fontSize: { xs: "0.65rem", sm: "0.7rem" },
//               borderRadius: 0,
//               px: { xs: 1, sm: 2 },
//               minWidth: { sm: 120 },
//               whiteSpace: "nowrap",
//             }}
//           >
//             {loading ? (
//               <CircularProgress size={18} color="inherit" />
//             ) : editIssue ? (
//               "Update"
//             ) : (
//               "Submit"
//             )}
//           </Button>
//         </Grid>
//       </Grid>

//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         theme={isDark ? "dark" : "light"}
//       />

//       {/* ── Main Form Box ── */}
//       <Box
//         sx={{
//           border: "1px solid",
//           borderColor: "divider",
//           borderRadius: 1,
//           p: { xs: 1, sm: 1.5 },
//           bgcolor: "background.paper",
//           backgroundImage: "none",
//           boxShadow: isDark ? "0 4px 18px rgba(0,0,0,0.35)" : "none",
//           mt: 1,
//         }}
//       >
//         <form onSubmit={handleSubmit}>
//           <Grid container spacing={2}>
//             {/* Voucher No */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="Voucher No."
//                 value={formData.purchase_number}
//                 size="small"
//                 disabled
//                 sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//               />
//             </Grid>

//             {/* Invoice No */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="Invoice No."
//                 value={formData.invoice_number}
//                 onChange={(e) =>
//                   handleFieldChange("invoice_number", e.target.value)
//                 }
//                 size="small"
//                 error={!!formErrors.invoice_number}
//                 helperText={formErrors.invoice_number}
//               />
//             </Grid>

//             {/* Invoice Date */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="Invoice Date"
//                 type="date"
//                 value={formData.invoice_date}
//                 onChange={(e) =>
//                   handleFieldChange("invoice_date", e.target.value)
//                 }
//                 size="small"
//                 InputLabelProps={{ shrink: true }}
//                 error={!!formErrors.invoice_date}
//                 helperText={formErrors.invoice_date}
//               />
//             </Grid>

//             {/* Purchase Order */}
//             <Grid item xs={12} sm={6} md={3}>
//               <Autocomplete
//                 options={purchases}
//                 getOptionLabel={(option) => option.po_number || ""}
//                 value={selectedPO}
//                 onChange={handlePOChange}
//                 isOptionEqualToValue={(option, value) =>
//                   option.po_id === value?.po_id
//                 }
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Purchase Order"
//                     size="small"
//                     error={!!formErrors.purchase}
//                     helperText={formErrors.purchase}
//                   />
//                 )}
//               />
//             </Grid>

//             {/* MOS */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="MOS"
//                 name="project_name"
//                 value={formData.project_name || ""}
//                 disabled
//                 size="small"
//                 sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//               />
//             </Grid>

//             {/* Supplier */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="Supplier"
//                 name="supplier_name"
//                 value={formData.supplier_name || ""}
//                 size="small"
//                 disabled
//                 sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//               />
//             </Grid>

//             {/* LR No */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="LR No"
//                 value={formData.lr_no}
//                 onChange={(e) => handleFieldChange("lr_no", e.target.value)}
//                 size="small"
//               />
//             </Grid>

//             {/* GRN No */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="GRN No"
//                 value={formData.grn_no}
//                 onChange={(e) => handleFieldChange("grn_no", e.target.value)}
//                 size="small"
//               />
//             </Grid>

//             {/* Vehicle No */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="Vehicle No"
//                 value={formData.vehicle_no}
//                 onChange={(e) =>
//                   handleFieldChange("vehicle_no", e.target.value)
//                 }
//                 size="small"
//               />
//             </Grid>

//             {/* Payment Status */}
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 label="Payment Status"
//                 value={formData.payment_status}
//                 onChange={(e) =>
//                   handleFieldChange("payment_status", e.target.value)
//                 }
//                 select
//                 size="small"
//               >
//                 <MenuItem value="Paid">Paid</MenuItem>
//                 <MenuItem value="Unpaid">Unpaid</MenuItem>
//                 <MenuItem value="Partial">Partial</MenuItem>
//               </TextField>
//             </Grid>

//             {/* Attachment */}
//             <Grid item xs={12} sm={6} md={3}>
//               <Box>
//                 <TextField
//                   fullWidth
//                   type="file"
//                   onChange={(e) => {
//                     const file = e.target.files[0];
//                     setFormData((prev) => ({ ...prev, attachment: file }));
//                     setExistingFileName("");
//                   }}
//                   label={existingFileName ? "Change Attachment" : "Attachment"}
//                   size="small"
//                   InputLabelProps={{ shrink: true }}
//                 />
//                 {existingFileName && formData.attachment && editIssue && (
//                   <Box mt={0.5} display="flex" alignItems="center" gap={1}>
//                     <Typography
//                       variant="caption"
//                       sx={{ color: "text.secondary" }}
//                     >
//                       {existingFileName}
//                     </Typography>
//                     {typeof formData.attachment === "string" && (
//                       <IconButton
//                         size="small"
//                         component="a"
//                         href={formData.attachment}
//                         target="_blank"
//                       >
//                         <Visibility fontSize="small" color="primary" />
//                       </IconButton>
//                     )}
//                   </Box>
//                 )}
//               </Box>
//             </Grid>

//             {/* ── Items Section ── */}
//             <Grid item xs={12}>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   my: { xs: 1, sm: 2 },
//                   fontSize: { xs: "0.9rem", sm: "1.1rem" },
//                   fontWeight: 700,
//                   color: "text.primary",
//                 }}
//               >
//                 Items
//               </Typography>

//               {isMobile ? (
//                 <Box>
//                   {formData.items.map((row, index) => (
//                     <MobileItemCard key={index} row={row} index={index} />
//                   ))}
//                 </Box>
//               ) : (
//                 <TableContainer
//                   sx={{
//                     border: "1px solid",
//                     borderColor: "divider",
//                     borderRadius: 1,
//                     bgcolor: "background.paper",
//                   }}
//                 >
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow
//                         sx={{
//                           bgcolor: isDark
//                             ? alpha(theme.palette.primary.main, 0.15)
//                             : "#f0f4ff",
//                           "& th": {
//                             fontWeight: "bold",
//                             color: "text.primary",
//                             borderBottom: "2px solid",
//                             borderColor: "primary.main",
//                             fontSize: "0.75rem",
//                             whiteSpace: "nowrap",
//                           },
//                         }}
//                       >
//                         <TableCell>Sl.</TableCell>
//                         <TableCell>Category</TableCell>
//                         <TableCell>Item</TableCell>
//                         <TableCell>Product Type</TableCell>
//                         <TableCell>UOM</TableCell>
//                         <TableCell>PO Qty</TableCell>
//                         <TableCell>Rec Qty</TableCell>
//                         <TableCell>Rate</TableCell>
//                         <TableCell>Amount</TableCell>
//                         <TableCell>GST %</TableCell>
//                         <TableCell>GST Amt</TableCell>
//                         <TableCell>Total</TableCell>
//                         <TableCell>Action</TableCell>
//                       </TableRow>
//                     </TableHead>

//                     <TableBody>
//                       {formData.items.map((row, index) => (
//                         <TableRow
//                           key={index}
//                           sx={{
//                             bgcolor:
//                               index % 2 === 0
//                                 ? isDark
//                                   ? alpha(theme.palette.common.white, 0.03)
//                                   : "#fafafa"
//                                 : "background.paper",
//                             "&:hover": {
//                               bgcolor: isDark
//                                 ? alpha(theme.palette.primary.main, 0.08)
//                                 : "#f0f7ff",
//                             },
//                             "& td": {
//                               borderBottom: "1px solid",
//                               borderColor: "divider",
//                             },
//                           }}
//                         >
//                           <TableCell sx={{ color: "text.secondary" }}>
//                             {index + 1}
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               value={row.category_name}
//                               size="small"
//                               sx={{
//                                 minWidth: 120,
//                                 "& .MuiInputBase-root": {
//                                   bgcolor: disabledBg,
//                                 },
//                               }}
//                               disabled
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               value={row.item_name}
//                               size="small"
//                               sx={{
//                                 minWidth: 120,
//                                 "& .MuiInputBase-root": {
//                                   bgcolor: disabledBg,
//                                 },
//                               }}
//                               disabled
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               value={row.size_name}
//                               size="small"
//                               sx={{
//                                 minWidth: 80,
//                                 "& .MuiInputBase-root": {
//                                   bgcolor: disabledBg,
//                                 },
//                               }}
//                               disabled
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               value={row.unit_name}
//                               size="small"
//                               sx={{
//                                 minWidth: 80,
//                                 "& .MuiInputBase-root": {
//                                   bgcolor: disabledBg,
//                                 },
//                               }}
//                               disabled
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               value={row.quantity}
//                               size="small"
//                               sx={{
//                                 minWidth: 80,
//                                 "& .MuiInputBase-root": {
//                                   bgcolor: disabledBg,
//                                 },
//                               }}
//                               disabled
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               type="number"
//                               value={row.received_qty}
//                               onChange={(e) =>
//                                 handleItemChange(
//                                   index,
//                                   "received_qty",
//                                   e.target.value
//                                 )
//                               }
//                               size="small"
//                               sx={{ minWidth: 80 }}
//                               error={!!rowErrors[index]?.received_qty}
//                               helperText={rowErrors[index]?.received_qty}
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               type="number"
//                               value={row.rate}
//                               onChange={(e) =>
//                                 handleItemChange(index, "rate", e.target.value)
//                               }
//                               size="small"
//                               sx={{ minWidth: 80 }}
//                               error={!!rowErrors[index]?.rate}
//                               helperText={rowErrors[index]?.rate}
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               value={row.amount}
//                               size="small"
//                               sx={{
//                                 minWidth: 100,
//                                 "& .MuiInputBase-root": {
//                                   bgcolor: disabledBg,
//                                 },
//                               }}
//                               disabled
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               type="number"
//                               value={row.gst_percentage}
//                               onChange={(e) =>
//                                 handleItemChange(
//                                   index,
//                                   "gst_percentage",
//                                   e.target.value
//                                 )
//                               }
//                               size="small"
//                               sx={{ minWidth: 80 }}
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               value={row.gst_amount}
//                               size="small"
//                               sx={{
//                                 minWidth: 100,
//                                 "& .MuiInputBase-root": {
//                                   bgcolor: disabledBg,
//                                 },
//                               }}
//                               disabled
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <TextField
//                               value={row.item_total}
//                               size="small"
//                               sx={{
//                                 minWidth: 100,
//                                 "& .MuiInputBase-root": {
//                                   bgcolor: disabledBg,
//                                   fontWeight: "bold",
//                                 },
//                               }}
//                               disabled
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <IconButton
//                               color="error"
//                               onClick={() => removeItem(index)}
//                               disabled={formData.items.length === 1}
//                               size="small"
//                               sx={{
//                                 "&:hover": {
//                                   bgcolor: (t) =>
//                                     t.palette.mode === "dark"
//                                       ? alpha(t.palette.error.main, 0.15)
//                                       : "#ffebee",
//                                 },
//                               }}
//                             >
//                               <DeleteOutlineIcon fontSize="small" />
//                             </IconButton>
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               )}
//             </Grid>

//             {/* ── Summary Section ── */}
//             <Grid item xs={12} sm={6} md={4}>
//               <TextField
//                 fullWidth
//                 label="Narration"
//                 value={formData.narration}
//                 onChange={(e) =>
//                   handleFieldChange("narration", e.target.value)
//                 }
//                 size="small"
//                 multiline
//                 rows={1}
//                 sx={{
//                   "& .MuiOutlinedInput-root": { padding: "6px 10px" },
//                   "& textarea": {
//                     overflow: "auto !important",
//                     maxHeight: "20px",
//                   },
//                 }}
//               />
//             </Grid>

//             <Grid item xs={6} sm={6} md={2}>
//               <TextField
//                 fullWidth
//                 label="Total Amount"
//                 value={formData.total_amount}
//                 size="small"
//                 disabled
//                 sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//               />
//             </Grid>

//             <Grid item xs={6} sm={6} md={2}>
//               <TextField
//                 fullWidth
//                 label="Total GST"
//                 value={formData.gst_amount}
//                 size="small"
//                 disabled
//                 sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }}
//               />
//             </Grid>

//             <Grid item xs={6} sm={6} md={2}>
//               <TextField
//                 fullWidth
//                 label="Other Expense"
//                 type="number"
//                 value={formData.other_expense}
//                 onChange={(e) => handleOtherExpenseChange(e.target.value)}
//                 size="small"
//                 InputProps={{ inputProps: { min: 0, step: "0.01" } }}
//               />
//             </Grid>

//             <Grid item xs={6} sm={6} md={2}>
//               <TextField
//                 fullWidth
//                 label="Grand Total"
//                 value={formData.final_amount}
//                 size="small"
//                 disabled
//                 sx={{
//                   "& .MuiInputBase-root": {
//                     bgcolor: isDark
//                       ? alpha(theme.palette.success.main, 0.12)
//                       : "#e8f5e9",
//                     fontWeight: "bold",
//                   },
//                 }}
//               />
//             </Grid>
//           </Grid>
//         </form>
//       </Box>
//     </Box>
//   );
// };

// export default GoodReceivedForm;


import React, { useState, useEffect } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Grid,
  IconButton,
  TableContainer,
  Table,
  Box,
  TableCell,
  Autocomplete,
  TableHead,
  TableRow,
  TableBody,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme,
  Divider,
  alpha,
  CircularProgress,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  ApproveTransporterList,
  CreatePurchaseVoucher,
  fetchpos,
  UpdatePurchaseVoucher,
  GetNextPvNo,
  GetPurchaseVoucherById,
} from "../../../Services/Services";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

// ── Empty item template ──
const createEmptyItem = () => ({
  category: "",
  sub_category: "",
  item: "",
  description: "",
  quantity: "",
  received_qty: "",
  unit: "",
  rate: "",
  amount: "0.00",
  size: "",
  size_name: "",
  gst_percentage: "",
  gst_amount: "0.00",
  item_total: "0.00",
  category_name: "",
  sub_category_name: "",
  item_name: "",
  unit_name: "",
});

// ── Calculate helpers ──
const calcAmount = (qty, rate) =>
  ((parseFloat(qty) || 0) * (parseFloat(rate) || 0)).toFixed(2);

const calcGST = (amount, gstPercent) =>
  (((parseFloat(amount) || 0) * (parseFloat(gstPercent) || 0)) / 100).toFixed(2);

const calcItemTotal = (amount, gstAmount) =>
  ((parseFloat(amount) || 0) + (parseFloat(gstAmount) || 0)).toFixed(2);

const calcTotalAmount = (items) =>
  items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0).toFixed(2);

const calcTotalGST = (items) =>
  items.reduce((sum, item) => sum + (parseFloat(item.gst_amount) || 0), 0).toFixed(2);

const calcFinalAmount = (items, otherExpense) =>
  (
    items.reduce((sum, item) => sum + (parseFloat(item.item_total) || 0), 0) +
    (parseFloat(otherExpense) || 0)
  ).toFixed(2);

// ── Division helper ──
const getSelectedDivision = () => {
  try {
    const stored = localStorage.getItem("selectedDivision");
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

const GoodReceivedForm = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  const editIssue = location.state?.issue || null;

  const storedDivision = getSelectedDivision();

  const disabledBg = isDark
    ? alpha(theme.palette.common.white, 0.06)
    : "#f5f5f5";

  // ── States ──
  const [formData, setFormData] = useState({
    purchase_voucher_no: "",
    purchase_number: "",
    project: "",
    indent: "",
    purchase: "",
    division: storedDivision?.division_id || "",
    division_name: storedDivision?.division || "",
    transporter_name: "",
    invoice_number: "",
    lr_no: "",
    vehicle_no: "",
    payment_status: "",
    supplier: "",
    invoice_date: "",
    narration: "",
    gst_amount: "0.00",
    total_amount: "0.00",
    other_expense: "",    // ✅ Empty by default, not "0"
    final_amount: "0.00",
    grn_no: "",
    attachment: "",
    project_name: "",
    supplier_name: "",
    indent_no: "",
    items: [createEmptyItem()],
    created_by: localStorage.getItem("user_id"),
  });

  const [purchases, setPurchases] = useState([]);
  const [selectedPO, setSelectedPO] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]);
  const [transporterLists, setTransporterLists] = useState([]);
  const [existingFileName, setExistingFileName] = useState("");

  // ── Item handlers ──
  const handleItemChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    updatedItems[index][field] = value;
    const row = updatedItems[index];

    if (field === "received_qty" || field === "rate") {
      row.amount = calcAmount(row.received_qty, row.rate);
      row.gst_amount = calcGST(row.amount, row.gst_percentage);
      row.item_total = calcItemTotal(row.amount, row.gst_amount);
    }

    if (field === "gst_percentage") {
      row.gst_amount = calcGST(row.amount, row.gst_percentage);
      row.item_total = calcItemTotal(row.amount, row.gst_amount);
    }

    setFormData((prev) => ({
      ...prev,
      items: updatedItems,
      total_amount: calcTotalAmount(updatedItems),
      gst_amount: calcTotalGST(updatedItems),
      final_amount: calcFinalAmount(updatedItems, prev.other_expense),
    }));

    const newRowErrors = [...rowErrors];
    if (newRowErrors[index]) delete newRowErrors[index][field];
    setRowErrors(newRowErrors);
  };

  // ✅ Other Expense Fix - empty string allowed, 0.00 nahi dikhega
  const handleOtherExpenseChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      other_expense: value,
      final_amount: calcFinalAmount(prev.items, value),
    }));
  };

  const addItem = () => {
    setFormData((prev) => ({
      ...prev,
      items: [...prev.items, createEmptyItem()],
    }));
  };

  const removeItem = (index) => {
    if (formData.items.length === 1) {
      toast.warning("At least one item is required");
      return;
    }
    const items = formData.items.filter((_, i) => i !== index);
    setFormData((prev) => ({
      ...prev,
      items,
      total_amount: calcTotalAmount(items),
      gst_amount: calcTotalGST(items),
      final_amount: calcFinalAmount(items, prev.other_expense),
    }));
    setRowErrors((prev) => prev.filter((_, i) => i !== index));
  };

  // ── PO Change ──
  const handlePOChange = (event, newValue) => {
    setSelectedPO(newValue);
    const divisionData = getSelectedDivision();

    if (newValue) {
      const mappedItems = (newValue.items || []).map((item) => ({
        category: item.category?.id || item.category,
        category_name: item.category?.name || item.category_name || "",
        sub_category: item.sub_category?.subcat_id || item.sub_category?.id || item.sub_category,
        sub_category_name: item.sub_category?.name || item.sub_category_name || "",
        item: item.item?.id || item.item,
        item_name: item.item?.name || item.item_name || "",
        unit: item.unit?.id || item.unit,
        unit_name: item.unit?.name || item.unit_name || "",
        description: item.description || "",
        quantity: item.quantity || "",
        received_qty: "",
        rate: item.rate || "",
        amount: "0.00",
        size: item.size || "",
        size_name: item.size_name || "",
        gst_percentage: item.gst_percentage || "",
        gst_amount: "0.00",
        item_total: "0.00",
      }));

      setFormData((prev) => ({
        ...prev,
        purchase: newValue.po_id || newValue.id,
        project: newValue.project || "",
        division: divisionData?.division_id || "",
        division_name: divisionData?.division || "",
        supplier: newValue.supplier || "",
        indent: newValue.indent || "",
        project_name: newValue.project_name || "",
        supplier_name: newValue.supplier_name || "",
        indent_no: newValue.indent_no || "",
        items: mappedItems,
        total_amount: "0.00",
        gst_amount: "0.00",
        final_amount: "0.00",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        purchase: "",
        project: "",
        division: divisionData?.division_id || "",
        division_name: divisionData?.division || "",
        supplier: "",
        indent: "",
        project_name: "",
        supplier_name: "",
        indent_no: "",
        items: [createEmptyItem()],
        total_amount: "0.00",
        gst_amount: "0.00",
        final_amount: "0.00",
      }));
    }
  };

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // ── Fetch data ──
  useEffect(() => {
    Promise.all([fetchNextPvNo(), fetchPOs(), fetchTransporterLists()]);
  }, []);

  const fetchNextPvNo = async () => {
    if (editIssue) return;   // don't overwrite edit mode data
    try {
      const data = await GetNextPvNo();
      const no = data?.purchase_number || data?.purchase_voucher_no;
      if (no) {
        setFormData((prev) => ({ ...prev, purchase_number: no }));
      }
    } catch (error) {
      console.error("Error fetching PV number:", error);
    }
  };

  const fetchPOs = async () => {
    try {
      const divisionData = getSelectedDivision();
      const filters = {
        approval_status: "Approved",
        ...(divisionData?.division_id && { division: divisionData.division_id }),
      };
      const data = await fetchpos(filters);
      if (Array.isArray(data.results)) setPurchases(data.results);
    } catch (error) {
      console.error("Error fetching POs:", error);
    }
  };

  const fetchTransporterLists = async () => {
    try {
      const data = await ApproveTransporterList();
      setTransporterLists(Array.isArray(data) ? data : data?.results || []);
    } catch (error) {
      console.error("Error fetching transporters:", error);
    }
  };

  // ── Edit mode ──
  useEffect(() => {
    if (!editIssue || !purchases.length) return;

    const loadEditData = async () => {
      try {
        const fullData = await GetPurchaseVoucherById(editIssue.purchase_voucher_no);
        if (!fullData) return;

        const divisionData = getSelectedDivision();

        if (fullData.attachment) {
          const fullPath = fullData.attachment.split("/").pop();
          setExistingFileName(fullPath.split("?")[0]);
        }

        const po = purchases.find((p) => String(p.po_id) === String(fullData.purchase));
        setSelectedPO(po || null);

        setFormData({
          purchase_voucher_no: fullData.purchase_voucher_no || "",
          purchase_number: fullData.purchase_number || "",
          division: divisionData?.division_id || fullData.division || "",
          division_name: divisionData?.division || fullData.division_name || "",
          project: fullData.project || "",
          purchase: fullData.purchase || "",
          supplier: fullData.supplier || "",
          indent: fullData.indent || "",
          project_name: fullData.project_name || "",
          indent_no: fullData.indent_no || "",
          supplier_name: fullData.supplier_name || "",
          invoice_number: fullData.invoice_number || "",
          invoice_date: fullData.invoice_date || "",
          transporter_name: fullData.transporter_name || "",
          lr_no: fullData.lr_no || "",
          vehicle_no: fullData.vehicle_no || "",
          payment_status: fullData.payment_status || "",
          narration: fullData.narration || "",
          total_amount: fullData.total_amount || "0.00",
          gst_amount: fullData.gst_amount?.toString() || "0.00",
          other_expense: fullData.other_expense || "",   // ✅ Empty if 0
          final_amount: fullData.final_amount || "0.00",
          grn_no: fullData.grn_no || "",
          attachment: fullData.attachment || "",
          created_by: localStorage.getItem("user_id"),
          items: (fullData.good_items || fullData.items || []).map((item) => ({
            category: item.category || "",
            category_name: item.category_name || "",
            sub_category: item.sub_category || "",
            sub_category_name: item.sub_category_name || "",
            item: item.item || "",
            item_name: item.item_name || "",
            description: item.description || "",
            received_qty: item.received_qty || "",
            quantity: item.quantity || "",
            unit: item.unit || "",
            unit_name: item.unit_name || "",
            rate: item.rate || "",
            amount: item.amount || "0.00",
            size: item.size || "",
            size_name: item.size_name || "",
            gst_percentage: item.gst_percentage?.toString() || "",
            gst_amount: item.gst_amount?.toString() || "0.00",
            item_total: item.item_total?.toString() || "0.00",
          })),
        });
      } catch {
        toast.error("Failed to load voucher data");
      }
    };

    loadEditData();
  }, [editIssue, purchases]);

  // ── Validation ──
  const validateForm = () => {
    const errors = {};
    const rowErrs = [];

    if (!formData.purchase) errors.purchase = "Purchase Order is required";

    formData.items.forEach((row, i) => {
      const err = {};
      if (!row.received_qty || row.received_qty === "") err.received_qty = "Required";
      if (!row.rate || row.rate === "") err.rate = "Required";
      if (Object.keys(err).length) rowErrs[i] = err;
    });

    setFormErrors(errors);
    setRowErrors(rowErrs);
    return Object.keys(errors).length === 0 && rowErrs.every((e) => !e);
  };

  // ── Submit ──
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!validateForm()) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {
      const fd = new FormData();
      fd.append("purchase_number", formData.purchase_number || "");
      fd.append("purchase_voucher_no", formData.purchase_voucher_no || "");
      fd.append("project", formData.project || "");
      fd.append("purchase", formData.purchase || "");
      fd.append("supplier", formData.supplier || "");
      fd.append("indent", formData.indent || "");
      fd.append("invoice_number", formData.invoice_number || "");
      fd.append("invoice_date", formData.invoice_date || "");
      fd.append("transporter_name", formData.transporter_name || "");
      fd.append("lr_no", formData.lr_no || "");
      fd.append("vehicle_no", formData.vehicle_no || "");
      fd.append("payment_status", formData.payment_status || "");
      fd.append("narration", formData.narration || "");
      fd.append("total_amount", formData.total_amount || "0.00");
      fd.append("gst_amount", formData.gst_amount || "0.00");
      fd.append("other_expense", formData.other_expense || "0");  // ✅ Backend ko 0 bhejo
      fd.append("final_amount", formData.final_amount || "0.00");
      fd.append("grn_no", formData.grn_no || "");

      if (formData.attachment instanceof File) {
        fd.append("attachment", formData.attachment);
      }

      const cleanedItems = formData.items.map((row) => ({
        category: row.category || null,
        sub_category: row.sub_category || null,
        item: row.item || null,
        unit: row.unit || null,
        description: row.description || "",
        quantity: Number(row.quantity) || 0,
        received_qty: Number(row.received_qty) || 0,
        rate: Number(row.rate) || 0,
        amount: Number(row.amount) || 0,
        size: row.size || "",
        gst_percentage: Number(row.gst_percentage) || 0,
        gst_amount: Number(row.gst_amount) || 0,
        item_total: Number(row.item_total) || 0,
      }));

      fd.append("good_items", JSON.stringify(cleanedItems));

      if (editIssue?.purchase_voucher_no) {
        const response = await UpdatePurchaseVoucher(editIssue.purchase_voucher_no, fd);
        if (response) {
          toast.success("Purchase Entry Updated!");
          setTimeout(() => navigate("/dashboard/purchase-list"), 1500);
        }
      } else {
        fd.append("created_by", localStorage.getItem("user_id"));
        const response = await CreatePurchaseVoucher(fd);
        if (response) {
          toast.success("Purchase Entry Created!");
          setTimeout(() => navigate("/dashboard/purchase-list"), 1500);
        }
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Operation failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        px: { xs: 1, sm: 0 },
        mt: { xs: 4, md: 0 },
        bgcolor: "background.default",
        minHeight: "100%",
      }}
    >
      {/* Top Bar */}
      <Grid
        container
        spacing={1}
        alignItems="center"
        sx={{
          mb: 1,
          mt: { xs: 3, md: 0 },
          position: "sticky",
          top: 0,
          zIndex: 1100,
          pt: 1,
          pb: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: (t) => alpha(t.palette.background.paper, 0.95),
          backdropFilter: "blur(8px)",
          boxShadow: isDark ? "0 2px 10px rgba(0,0,0,0.45)" : "0 1px 4px rgba(0,0,0,0.07)",
        }}
      >
        <Grid item sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }} />
        <Grid item xs={6} sm="auto">
          <Button
            fullWidth
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{ height: 32, fontSize: "0.7rem", borderRadius: 0, minWidth: { sm: 100 } }}
          >
            ← Back
          </Button>
        </Grid>
        <Grid item xs={6} sm="auto">
          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{ height: 32, fontSize: "0.7rem", borderRadius: 0, minWidth: { sm: 120 } }}
          >
            {loading ? <CircularProgress size={18} color="inherit" /> : editIssue ? "Update" : "Submit"}
          </Button>
        </Grid>
      </Grid>

      <ToastContainer position="top-right" autoClose={3000} theme={isDark ? "dark" : "light"} />

      {/* Form */}
      <Box
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          p: { xs: 1, sm: 1.5 },
          bgcolor: "background.paper",
          backgroundImage: "none",
          boxShadow: isDark ? "0 4px 18px rgba(0,0,0,0.35)" : "none",
          mt: 1,
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Voucher No." value={formData.purchase_number} size="small" disabled
                sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Invoice No." value={formData.invoice_number}
                onChange={(e) => handleFieldChange("invoice_number", e.target.value)} size="small" />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Invoice Date" type="date" value={formData.invoice_date}
                onChange={(e) => handleFieldChange("invoice_date", e.target.value)}
                size="small" InputLabelProps={{ shrink: true }} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                options={purchases}
                getOptionLabel={(option) => option.po_number || ""}
                value={selectedPO}
                onChange={handlePOChange}
                isOptionEqualToValue={(option, value) => option.po_id === value?.po_id}
                renderInput={(params) => (
                  <TextField {...params} label="Purchase Order" size="small"
                    error={!!formErrors.purchase} helperText={formErrors.purchase} />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="MOS" value={formData.project_name || ""} disabled size="small"
                sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Supplier" value={formData.supplier_name || ""} size="small" disabled
                sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="LR No" value={formData.lr_no}
                onChange={(e) => handleFieldChange("lr_no", e.target.value)} size="small" />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="GRN No" value={formData.grn_no}
                onChange={(e) => handleFieldChange("grn_no", e.target.value)} size="small" />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Vehicle No" value={formData.vehicle_no}
                onChange={(e) => handleFieldChange("vehicle_no", e.target.value)} size="small" />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField fullWidth label="Payment Status" value={formData.payment_status}
                onChange={(e) => handleFieldChange("payment_status", e.target.value)} select size="small">
                <MenuItem value="Paid">Paid</MenuItem>
                <MenuItem value="Unpaid">Unpaid</MenuItem>
                <MenuItem value="Partial">Partial</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box>
                <TextField fullWidth type="file"
                  onChange={(e) => {
                    setFormData((prev) => ({ ...prev, attachment: e.target.files[0] }));
                    setExistingFileName("");
                  }}
                  label={existingFileName ? "Change Attachment" : "Attachment"}
                  size="small" InputLabelProps={{ shrink: true }} />
                {existingFileName && formData.attachment && editIssue && (
                  <Box mt={0.5} display="flex" alignItems="center" gap={1}>
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>
                      {existingFileName}
                    </Typography>
                    {typeof formData.attachment === "string" && (
                      <IconButton size="small" component="a" href={formData.attachment} target="_blank">
                        <Visibility fontSize="small" color="primary" />
                      </IconButton>
                    )}
                  </Box>
                )}
              </Box>
            </Grid>

            {/* Items */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ my: { xs: 1, sm: 2 }, fontSize: "1rem", fontWeight: 700 }}>
                Items
              </Typography>

              {isMobile ? (
                <Box>
                  {formData.items.map((row, index) => (
                    <Card key={index} elevation={0} sx={{
                      mb: 1.5, border: "1px solid", borderColor: "divider", borderRadius: 1,
                      bgcolor: "background.paper", backgroundImage: "none",
                    }}>
                      <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                          <Typography variant="subtitle2" sx={{ fontSize: "0.8rem", fontWeight: 700, color: "primary.main" }}>
                            Item #{index + 1}
                          </Typography>
                          <IconButton color="error" size="small" onClick={() => removeItem(index)}
                            disabled={formData.items.length === 1}>
                            <DeleteOutlineIcon fontSize="small" />
                          </IconButton>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                          <Grid item xs={12}><TextField fullWidth label="Product Type" value={row.size_name || ""} size="small" disabled sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} /></Grid>
                          <Grid item xs={12}><TextField fullWidth label="Category" value={row.category_name || ""} size="small" disabled sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} /></Grid>
                          <Grid item xs={12}><TextField fullWidth label="Item" value={row.item_name || ""} size="small" disabled sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} /></Grid>
                          <Grid item xs={6}><TextField fullWidth label="UOM" value={row.unit_name || ""} size="small" disabled sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} /></Grid>
                          <Grid item xs={6}><TextField fullWidth label="PO Qty" value={row.quantity || 0} size="small" disabled sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} /></Grid>
                          <Grid item xs={6}><TextField fullWidth label="Received Qty" type="number" value={row.received_qty || ""} onChange={(e) => handleItemChange(index, "received_qty", e.target.value)} size="small" error={!!rowErrors[index]?.received_qty} helperText={rowErrors[index]?.received_qty} /></Grid>
                          <Grid item xs={6}><TextField fullWidth label="Rate" type="number" value={row.rate || ""} onChange={(e) => handleItemChange(index, "rate", e.target.value)} size="small" error={!!rowErrors[index]?.rate} helperText={rowErrors[index]?.rate} /></Grid>
                          <Grid item xs={6}><TextField fullWidth label="GST %" type="number" value={row.gst_percentage || ""} onChange={(e) => handleItemChange(index, "gst_percentage", e.target.value)} size="small" /></Grid>
                          <Grid item xs={6}><TextField fullWidth label="Amount" value={row.amount} size="small" disabled sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} /></Grid>
                          <Grid item xs={6}><TextField fullWidth label="GST Amt" value={row.gst_amount} size="small" disabled sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} /></Grid>
                          <Grid item xs={6}><TextField fullWidth label="Item Total" value={row.item_total} size="small" disabled sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg, fontWeight: "bold" } }} /></Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  ))}
                </Box>
              ) : (
                <TableContainer sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, bgcolor: "background.paper" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{
                        bgcolor: isDark ? alpha(theme.palette.primary.main, 0.15) : "#f0f4ff",
                        "& th": { fontWeight: "bold", color: "text.primary", borderBottom: "2px solid", borderColor: "primary.main", fontSize: "0.75rem", whiteSpace: "nowrap" },
                      }}>
                        <TableCell>Sl.</TableCell>
                        <TableCell>Product Type</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Item</TableCell>
                        <TableCell>UOM</TableCell>
                        <TableCell>PO Qty</TableCell>
                        <TableCell>Rec Qty</TableCell>
                        <TableCell>Rate</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>GST %</TableCell>
                        <TableCell>GST Amt</TableCell>
                        <TableCell>Total</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData.items.map((row, index) => (
                        <TableRow key={index} sx={{
                          bgcolor: index % 2 === 0
                            ? isDark ? alpha(theme.palette.common.white, 0.03) : "#fafafa"
                            : "background.paper",
                          "&:hover": { bgcolor: isDark ? alpha(theme.palette.primary.main, 0.08) : "#f0f7ff" },
                          "& td": { borderBottom: "1px solid", borderColor: "divider" },
                        }}>
                          <TableCell sx={{ color: "text.secondary" }}>{index + 1}</TableCell>
                          <TableCell><TextField value={row.size_name} size="small" sx={{ minWidth: 100, "& .MuiInputBase-root": { bgcolor: disabledBg } }} disabled /></TableCell>
                          <TableCell><TextField value={row.category_name} size="small" sx={{ minWidth: 120, "& .MuiInputBase-root": { bgcolor: disabledBg } }} disabled /></TableCell>
                          <TableCell><TextField value={row.item_name} size="small" sx={{ minWidth: 120, "& .MuiInputBase-root": { bgcolor: disabledBg } }} disabled /></TableCell>
                          <TableCell><TextField value={row.unit_name} size="small" sx={{ minWidth: 80, "& .MuiInputBase-root": { bgcolor: disabledBg } }} disabled /></TableCell>
                          <TableCell><TextField value={row.quantity} size="small" sx={{ minWidth: 80, "& .MuiInputBase-root": { bgcolor: disabledBg } }} disabled /></TableCell>
                          <TableCell><TextField type="number" value={row.received_qty} onChange={(e) => handleItemChange(index, "received_qty", e.target.value)} size="small" sx={{ minWidth: 80 }} error={!!rowErrors[index]?.received_qty} /></TableCell>
                          <TableCell><TextField type="number" value={row.rate} onChange={(e) => handleItemChange(index, "rate", e.target.value)} size="small" sx={{ minWidth: 80 }} error={!!rowErrors[index]?.rate} /></TableCell>
                          <TableCell><TextField value={row.amount} size="small" sx={{ minWidth: 100, "& .MuiInputBase-root": { bgcolor: disabledBg } }} disabled /></TableCell>
                          <TableCell><TextField type="number" value={row.gst_percentage} onChange={(e) => handleItemChange(index, "gst_percentage", e.target.value)} size="small" sx={{ minWidth: 80 }} /></TableCell>
                          <TableCell><TextField value={row.gst_amount} size="small" sx={{ minWidth: 100, "& .MuiInputBase-root": { bgcolor: disabledBg } }} disabled /></TableCell>
                          <TableCell><TextField value={row.item_total} size="small" sx={{ minWidth: 100, "& .MuiInputBase-root": { bgcolor: disabledBg, fontWeight: "bold" } }} disabled /></TableCell>
                          <TableCell>
                            <IconButton color="error" onClick={() => removeItem(index)} disabled={formData.items.length === 1} size="small">
                              <DeleteOutlineIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Grid>

            {/* Summary */}
            <Grid item xs={12} sm={6} md={4}>
              <TextField fullWidth label="Narration" value={formData.narration}
                onChange={(e) => handleFieldChange("narration", e.target.value)} size="small" multiline rows={1} />
            </Grid>

            <Grid item xs={6} sm={6} md={2}>
              <TextField fullWidth label="Total Amount" value={formData.total_amount} size="small" disabled
                sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} />
            </Grid>

            <Grid item xs={6} sm={6} md={2}>
              <TextField fullWidth label="Total GST" value={formData.gst_amount} size="small" disabled
                sx={{ "& .MuiInputBase-root": { bgcolor: disabledBg } }} />
            </Grid>

            {/* ✅ Other Expense - empty allowed */}
            <Grid item xs={6} sm={6} md={2}>
              <TextField fullWidth label="Other Expense" type="number"
                value={formData.other_expense}
                onChange={(e) => handleOtherExpenseChange(e.target.value)}
                size="small"
                InputProps={{ inputProps: { min: 0, step: "0.01" } }}
                placeholder="0"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={2}>
              <TextField fullWidth label="Grand Total" value={formData.final_amount} size="small" disabled
                sx={{
                  "& .MuiInputBase-root": {
                    bgcolor: isDark ? alpha(theme.palette.success.main, 0.12) : "#e8f5e9",
                    fontWeight: "bold",
                  },
                }} />
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default GoodReceivedForm;